// extracted by mini-css-extract-plugin
module.exports = {"root":"_94ec7c"};